"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var react_1 = __importDefault(require("react"));
var Menu_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu"));
var classnames_1 = __importDefault(require("classnames"));
var ArrowIcon_1 = __importDefault(require("../../Icons/ArrowIcon"));
var ChevronIcon_1 = __importDefault(require("../../Icons/ChevronIcon"));
require("./MenuItem.css");
var MenuItem = function (props) {
    var activePage = props.activePage, section = props.section, title = props.title, onToggleShowSubMenu = props.onToggleShowSubMenu, isMobile = props.isMobile;
    return (react_1.default.createElement(Menu_1.default.Item, { active: activePage === section, onMouseEnter: function (e) {
            return !isMobile && onToggleShowSubMenu(e, true, section);
        }, onMouseLeave: function (e) {
            return !isMobile && onToggleShowSubMenu(e, false, section);
        }, onClick: function (e) {
            isMobile && onToggleShowSubMenu(e, true, section);
        }, className: (0, classnames_1.default)('dui-menu-item', section, isMobile && 'mobile') },
        title,
        !isMobile && react_1.default.createElement(ChevronIcon_1.default, { down: true }),
        isMobile && react_1.default.createElement(ArrowIcon_1.default, null)));
};
exports.MenuItem = MenuItem;
